import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import CardEmpty from "Utils/Cards/CardEmpty";
import { PadresPTApi } from "./api/PadresPTApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { FiltrosPadresPT } from "./components/FiltrosPadresPT";
import { PadresPTTable } from "./components/PadresPTTable";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { FormPadresPT } from "./components/FormPadresPT";
import './styles/PadresPT.css';

export const PadresPT = ({}) => {
    const { control, watch } = useForm();

    const [padresPT, setPadresPT] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const [padrePTSeleccionado, setPadrePTSeleccionado] = useState(null);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);

    const {
        getPadresProductoTerminado,
        deletePadreProductoTerminado,
        cargando,
    } = PadresPTApi();

    const GetPadresPT = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            const response = await getPadresProductoTerminado(params);
            setPadresPT(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener padres de producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setPadresPT([]);
            setCantidadResultados(0);
        }
    };

    const EliminarPadrePT = async (id) => {
        try {
            await deletePadreProductoTerminado(id);
            NotificationManager.success(
                "Padre de producto terminado eliminado correctamente",
                "Éxito",
                3000,
            );
            GetPadresPT();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar padre de producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetPadresPT();
    }, [paginaSeleccionada, debouncedSearch]);

    const [modalNuevoOpened, setModalNuevoOpened] = useState(false);

    const CerrarModal = () => {
        setModalNuevoOpened(false);
        setPadrePTSeleccionado(null);
    };

    const SeleccionarPadrePTEdicion = (padrePT) => {
        setPadrePTSeleccionado(padrePT);
        setModalNuevoOpened(true);
    };

    return (
        <div className="padres-pt__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="padres-pt__table-header">
                        <FiltrosPadresPT
                            control={control}
                            onRefresh={() => {
                                GetPadresPT();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Nombre"}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={() => setModalNuevoOpened(true)}
                        >
                            Crear nuevo padre
                        </button>
                    </div>

                    <PadresPTTable
                        padresPT={padresPT}
                        EliminarPadrePT={EliminarPadrePT}
                        SeleccionarPadrePTEdicion={SeleccionarPadrePTEdicion}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
            <FormPadresPT
                opened={modalNuevoOpened}
                onClose={CerrarModal}
                onSuccess={GetPadresPT}
                padrePTSeleccionado={padrePTSeleccionado}
            />
        </div>
    );
};
